
import { useState, useEffect } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Ana Paula Silva',
    avatar: 'https://public.readdy.ai/ai/img_res/b2f467fc2715eca85a5b2249f4d3ba6e.jpg',
    rating: 5,
    text: 'O melhor frango frito que já comi na vida! O tempero é incrível, crocante por fora e suculento por dentro. Já virei cliente fiel e peço toda semana!',
    date: 'há 2 dias',
  },
  {
    id: 2,
    name: 'Carlos Eduardo',
    avatar: 'https://readdy.ai/api/search-image?query=young%20brazilian%20man%20smiling%20portrait%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20friendly%20expression%2C%20casual%20style%2C%20high%20quality%20photo&width=80&height=80&seq=t2&orientation=squarish',
    rating: 5,
    text: 'Atendimento rápido pelo WhatsApp e entrega pontual. O bucket chegou quentinho e bem embalado. Recomendo demais para toda a família!',
    date: 'há 5 dias',
  },
  {
    id: 3,
    name: 'Fernanda Oliveira',
    avatar: 'https://readdy.ai/api/search-image?query=brazilian%20woman%20smiling%20portrait%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20happy%20expression%2C%20casual%20style%2C%20high%20quality%20photo&width=80&height=80&seq=t3&orientation=squarish',
    rating: 5,
    text: 'Pedi para o aniversário do meu filho e foi um sucesso! Todo mundo amou. O frango é temperado na medida certa, sem exagero. Voltarei com certeza!',
    date: 'há 1 semana',
  },
  {
    id: 4,
    name: 'Ricardo Mendes',
    avatar: 'https://readdy.ai/api/search-image?query=middle%20aged%20brazilian%20man%20smiling%20portrait%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20friendly%20expression%2C%20casual%20style%2C%20high%20quality%20photo&width=80&height=80&seq=t4&orientation=squarish',
    rating: 5,
    text: 'Melhor custo-benefício da cidade! Porção generosa, sabor incrível e preço justo. O molho especial então... é de outro nível. Parabéns ao pessoal!',
    date: 'há 1 semana',
  },
  {
    id: 5,
    name: 'Juliana Costa',
    avatar: 'https://readdy.ai/api/search-image?query=young%20brazilian%20woman%20smiling%20portrait%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20cheerful%20expression%2C%20casual%20style%2C%20high%20quality%20photo&width=80&height=80&seq=t5&orientation=squarish',
    rating: 5,
    text: 'Descobri o Buckets Chicken há um mês e não consigo parar de pedir! O frango crocante é viciante. Atendimento pelo WhatsApp é super rápido e simpático.',
    date: 'há 2 semanas',
  },
  {
    id: 6,
    name: 'Marcos Souza',
    avatar: 'https://readdy.ai/api/search-image?query=young%20brazilian%20man%20smiling%20portrait%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20happy%20expression%2C%20casual%20style%2C%20high%20quality%20photo&width=80&height=80&seq=t6&orientation=squarish',
    rating: 5,
    text: 'Fiz o pedido pelo WhatsApp e em menos de 40 minutos estava na minha porta. Frango perfeito, bem temperado e crocante. Nota 10 para o Buckets Chicken!',
    date: 'há 3 semanas',
  },
];

export default function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const visibleCount = 3;

  const total = testimonials.length;

  const goTo = (index: number) => {
    if (isAnimating) return;
    setIsAnimating(true);
    setTimeout(() => {
      setCurrent(index);
      setIsAnimating(false);
    }, 300);
  };

  const prev = () => {
    goTo(current === 0 ? total - visibleCount : current - 1);
  };

  const next = () => {
    goTo(current >= total - visibleCount ? 0 : current + 1);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev >= total - visibleCount ? 0 : prev + 1));
    }, 4000);
    return () => clearInterval(interval);
  }, [total]);

  const visible = testimonials.slice(current, current + visibleCount);

  return (
    <section id="testimonials" className="py-16 md:py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-yellow-400/10 text-yellow-400 text-xs font-bold uppercase tracking-widest px-4 py-1 rounded-full mb-4">
            Depoimentos
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-3">
            O que nossos clientes dizem
          </h2>
          <p className="text-gray-400 text-sm md:text-base max-w-xl mx-auto">
            Mais de <strong className="text-yellow-400">500 clientes satisfeitos</strong> já pediram e aprovaram o sabor do Buckets Chicken!
          </p>
        </div>

        {/* Stars summary */}
        <div className="flex items-center justify-center gap-3 mb-10">
          <div className="flex items-center gap-1">
            {[1,2,3,4,5].map((s) => (
              <i key={s} className="ri-star-fill text-yellow-400 text-xl"></i>
            ))}
          </div>
          <span className="text-white font-bold text-lg">5.0</span>
          <span className="text-gray-400 text-sm">/ 5.0 — baseado em avaliações reais</span>
        </div>

        {/* Cards */}
        <div
          className={`grid grid-cols-1 md:grid-cols-3 gap-6 transition-opacity duration-300 ${isAnimating ? 'opacity-0' : 'opacity-100'}`}
        >
          {visible.map((t) => (
            <div
              key={t.id}
              className="bg-zinc-900 border border-yellow-400/10 rounded-2xl p-6 flex flex-col gap-4 hover:border-yellow-400/40 transition-all duration-300 hover:-translate-y-1"
            >
              {/* Stars */}
              <div className="flex items-center gap-1">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
              </div>

              {/* Text */}
              <p className="text-gray-300 text-sm leading-relaxed flex-1">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-2 border-t border-yellow-400/10">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">{t.name}</p>
                  <p className="text-gray-500 text-xs">{t.date}</p>
                </div>
                <div className="ml-auto w-6 h-6 flex items-center justify-center">
                  <i className="ri-verified-badge-fill text-yellow-400 text-lg"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Controls */}
        <div className="flex items-center justify-center gap-4 mt-10">
          <button
            onClick={prev}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-yellow-400/30 text-yellow-400 hover:bg-yellow-400 hover:text-black transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>

          <div className="flex gap-2">
            {Array.from({ length: total - visibleCount + 1 }).map((_, i) => (
              <button
                key={i}
                onClick={() => goTo(i)}
                className={`rounded-full transition-all duration-300 cursor-pointer ${
                  current === i ? 'bg-yellow-400 w-6 h-2' : 'bg-gray-600 w-2 h-2'
                }`}
              />
            ))}
          </div>

          <button
            onClick={next}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-yellow-400/30 text-yellow-400 hover:bg-yellow-400 hover:text-black transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="https://wa.me/5519971394274"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-yellow-400 text-black px-8 py-3 rounded-full font-bold hover:bg-yellow-300 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Peça agora pelo WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
